import React from "react";
import Button from "../Button";

/**
 * Load-failure panel. Fills its caller's grid at the same measure as the
 * content it replaces, and keeps the technical message as secondary detail
 * under a human headline.
 */
const Error = ({
  message,
  title = "We couldn’t load this just now",
  hint = "The service didn’t respond. Please try again in a moment.",
  onRetry,
}) => {
  const retry = onRetry || (() => window.location.reload());

  return (
    <div
      role="alert"
      className="flex w-full max-w-4xl flex-col items-start gap-6 rounded-2xl border border-hairline bg-mist-panel p-7 shadow-brand-sm sm:flex-row sm:items-center sm:p-9"
    >
      <span
        aria-hidden="true"
        className="bg-sunshine-soft text-spectrum-blue flex h-12 w-12 shrink-0 items-center justify-center rounded-brand"
      >
        <svg
          fill="none"
          height="24"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
          width="24"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 8v5" />
          <path d="M12 16.5h.01" />
        </svg>
      </span>

      <div className="min-w-0 flex-1">
        <h3 className="font-headline text-lg font-bold text-spectrum-blue sm:text-xl">
          {title}
        </h3>
        <p className="font-body mt-1.5 text-sm text-muted">{hint}</p>
        {message ? (
          <p className="font-body text-muted mt-3 text-xs">{message}</p>
        ) : null}
      </div>

      <div className="shrink-0">
        <Button type="button" variant="outlineOnLight" size="md" onClick={retry}>
          Try again
        </Button>
      </div>
    </div>
  );
};

export default Error;
